import { render, staticRenderFns } from "./ControleGaiolaContainer.vue?vue&type=template&id=afe9b004&scoped=true"
import script from "./ControleGaiolaContainer.vue?vue&type=script&lang=js"
export * from "./ControleGaiolaContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe9b004",
  null
  
)

export default component.exports